// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function AppleLogoIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M28.913 23.199a1.008 1.008 0 0 0-.35-.425C26.44 21.316 26 18.83 26 17c0-2.209 1.684-4.133 2.688-5.084a1 1 0 0 0 0-1.452C27.102 8.967 24.477 8 22 8a9.025 9.025 0 0 0-5 1.516 8.945 8.945 0 0 0-11.339 1.136A9.33 9.33 0 0 0 3 17.425a15.883 15.883 0 0 0 5.018 11.216A4.976 4.976 0 0 0 11.447 30h10.96a4.98 4.98 0 0 0 3.64-1.571 15.633 15.633 0 0 0 2.228-3.075c.878-1.604.765-1.854.637-2.155Zm-4.33 3.867A2.971 2.971 0 0 1 22.41 28h-10.96a2.978 2.978 0 0 1-2.055-.814A13.893 13.893 0 0 1 5 17.375a7.313 7.313 0 0 1 2.081-5.316A6.85 6.85 0 0 1 12 10h.098a6.932 6.932 0 0 1 4.277 1.535 1 1 0 0 0 1.25 0A6.93 6.93 0 0 1 22 10a8.829 8.829 0 0 1 4.5 1.294C24.875 13.109 24 15.102 24 17c0 2.971.955 5.341 2.773 6.913a13.23 13.23 0 0 1-2.19 3.153ZM17.03 5.75A5 5 0 0 1 21.875 2H22a1 1 0 1 1 0 2h-.125a3 3 0 0 0-2.905 2.25 1 1 0 0 1-1.938-.5h-.003Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
